import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ClearFilterRecords, SetFilterRecords } from './filter-records.actions';
import { IFilterRecords } from 'src/app/common/models/IFilterRecords';


export class FilterRecordsStateModel {
  data: IFilterRecords;
}

@State<FilterRecordsStateModel>({
    name: 'filterRecords',
    defaults: {
      data: null
    }
})

@Injectable()
export class FilterRecordsState {

    @Selector()
    static getFilterRecordsState(state: FilterRecordsStateModel) {
        return state;
    }

    @Action(SetFilterRecords)
    public setFilterRecords({ getState, setState }: StateContext<FilterRecordsStateModel>,
       { data }: SetFilterRecords) {
        const state = getState();
        setState({ ...state, data });
    }

    @Action(ClearFilterRecords)
    public clearFilterRecords({ getState, setState }: StateContext<FilterRecordsStateModel>) {
        const state = getState();
        setState({ ...state, data: null });
    }
}
